<template>
    <div>
        <p
            class="mb-3"
            :class="titleClass"
        >
            {{ $t(story.title) }}
        </p>

        <p 
            class="mb-3"
            :class="quoteClass"
        >
            <fa icon="quote-right" />
        </p>

        <b-btn
            variant="light"
            size="sm"
            :to="{
                name: `home${routePostfix}`,
                query: { story: story.id },
            }"
        >
            {{ $t('common.buttons.linkStory') }}
        </b-btn>
    </div>
</template>

<script>
export default {
    name: 'StoryLink',
    props: {
        story: {
            type: Object,
            required: true,
        },
        titleClass: {
            type: [ String, Array, Object ],
            default: 'text-white',
        },
        quoteClass: {
            type: [ String, Array, Object ],
            default: 'small text-danger',
        },
    },
    computed: {
        routePostfix() {
            return this.story.type === 'cancer' ? 'Cancer' : '';
        },
    },
};
</script>
